"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const SuggestionsQuery = (0, graphql_tag_1.default)(`query suggestQuery(
  $query: String!
  $termsSize: Int
  $productsSize: Int = 0
  $categoriesSize: Int
  $brandsSize: Int
  $partnerId: String
  $skipProducts: Boolean = false
) {
  suggest(
    suggestRequest: {
      query: $query
      termsSize: $termsSize
      productsSize: $productsSize
      categoriesSize: $categoriesSize
      brandsSize: $brandsSize
      metadata: { partnerId: $partnerId }
    }
  ) {
    terms {
      term
      count
    }
    products @skip(if: $skipProducts) {
      id
      variationId
      title
      price {
        realPrice: price
      }
      path
      image
    }
  }
}
`);
exports.default = SuggestionsQuery;
